import React from 'react';
import { PILLARS, PILLARS_HEADING, PILLARS_SUB } from '../../mock';
import { Sparkles, BookOpenText, Crown, Infinity as InfinityIcon } from 'lucide-react';

const ICONS = {
  Sparkles,
  BookOpenText,
  Crown,
  Infinity: InfinityIcon,
};

export default function Pillars() {
  return (
    <section id="program" className="relative py-24 md:py-32">
      <div className="max-w-7xl mx-auto px-6">
        <h2 className="font-serif text-center text-white text-[36px] md:text-[58px] leading-[1.05] tracking-tight whitespace-pre-line">
          {PILLARS_HEADING}
        </h2>
        <p className="mt-6 text-center max-w-2xl mx-auto text-neutral-400 text-[15px] md:text-[17px] leading-relaxed">
          {PILLARS_SUB}
        </p>

        <div className="mt-14 relative">
          <div className="pointer-events-none absolute inset-x-0 top-0 h-px bg-gradient-to-r from-transparent via-amber-300/40 to-transparent" />
          <div className="grid grid-cols-1 md:grid-cols-2 gap-5 md:gap-6">
            {PILLARS.map((p) => {
              const Icon = ICONS[p.icon] || Sparkles;
              return (
                <div
                  key={p.title}
                  className="group relative overflow-hidden rounded-2xl border border-white/10 bg-gradient-to-b from-navy-900/70 to-navy-950/70 p-7 md:p-9 transition-all duration-300 hover:border-amber-300/30 hover:-translate-y-[2px]"
                >
                  <div className="absolute -top-24 -right-24 w-64 h-64 rounded-full bg-amber-300/[0.05] blur-3xl group-hover:bg-amber-300/[0.12] transition-colors" />
                  <div className="absolute top-0 left-6 h-[2px] w-12 bg-amber-300/60" />
                  <div className="relative flex items-start gap-5">
                    <div className="shrink-0 w-14 h-14 rounded-xl bg-amber-300/10 border border-amber-300/20 flex items-center justify-center text-amber-300">
                      <Icon size={26} strokeWidth={1.4} />
                    </div>
                    <div className="flex-1">
                      <div className="flex items-center gap-3 mb-2">
                        <h3 className="font-serif text-white text-2xl md:text-[26px] tracking-tight">
                          {p.title}
                        </h3>
                        <span className="text-[10px] uppercase tracking-[0.18em] text-amber-300/80 border border-amber-300/30 rounded-full px-2 py-0.5">
                          {p.badge}
                        </span>
                      </div>
                      <p className="text-neutral-400 text-[14px] md:text-[15px] leading-relaxed">
                        {p.desc}
                      </p>
                    </div>
                  </div>
                </div>
              );
            })}
          </div>
        </div>
      </div>
    </section>
  );
}
